import { useEffect, useState } from "react";
import { Col, Form, FormGroup, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { MdErrorOutline } from "react-icons/md"
import { listObjectType } from "../../../../../services/filters.service";
import { CardDescription, DropdownFilter, ObjectsCategoryIcon } from "../../../styled"
import { Dropdown } from 'primereact/dropdown';
import { IMediaCategory } from "../../../../../models/IMediaCategory";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import { Link } from "react-router-dom";
import { Controller } from "react-hook-form";


export function ObjectCategoryForm(props: any) {
    const { t: translation } = useTranslation();

    const { updateData = false, handleSetValue, itemData, setPrice, control } = props

    const [categoriesItems, setCategoryItems] = useState<IMediaCategory[]>([]);
    const [category, setCategory] = useState<IMediaCategory>();
    const [categoryIcon, setCategoryIcon] = useState<string>('')
    const [useBasePrice, setUseBasePrice] = useState<boolean>(false)
    const [itemPrice, setItemPrice] = useState<any>(itemData?.price || null)
    const [pricePreview, setPricePreview] = useState<any>(itemData?.category.price_preview || 0)

    const [deliveryValues, setDeliveryValues] = useState<any[]>([]);

    useEffect(() => {
        if (updateData) {
            listObjectType().then(data => setCategoryItems(data))
        }
    }, [updateData])

    useEffect(() => {
        if (itemData) {
            setUseBasePrice(itemData.is_base_price)
            handleSetValue('is_base_price', itemData.is_base_price)
            handleCategorySelect(itemData.category.id)
        } else {
            handleSetValue('is_base_price', false)
        }
    }, [itemData])
    
    useEffect(() => {
        if (itemData) {
            setCategory(itemData.category.id)
            setDeliveryValues(itemData.delivery_values)
        }
    }, [itemData])

    useEffect(() => {
        handleSetValue('delivery_values', deliveryValues);
    }, [deliveryValues])

    useEffect(() => {
        if (setPrice) {
            setPrice(itemPrice)
        }
        handleSetValue('price', itemPrice)
    }, [itemPrice])

    useEffect(() => {
        if (pricePreview === 0) {
            setPricePreview(null)
        }
    }, [pricePreview])

    const handleCategorySelect = (e: any) => {
        setDeliveryValues([]);
        setCategory(e.value);
        handleSetValue('category', e.value)
        if (categoriesItems) {
            categoriesItems.forEach((_category: IMediaCategory) => {
                if (_category.id === e.value) {
                    setDeliveryValues(_category.list_fields || []);

                    if (!itemData) {
                        setPricePreview(_category.price)
                    } else {
                        if (_category.id === itemData?.category.id) {
                            setPricePreview(itemData?.category.price_preview)
                        } else {
                            setPricePreview(_category.price)
                        }
                    }

                    if (useBasePrice) {
                        setItemPrice(_category.price)
                    }

                    if (_category.category_icon) {
                        setCategoryIcon(_category.category_icon)
                    }
                }
            })
        }
    }

    const handleValueChange = (e: any, field: any) => {
        let json: any = []
        deliveryValues.forEach(fields => {
            if (fields.title === field.title) {
                fields.value = e.target.value
            }
            json.push(fields);
        })
        setDeliveryValues(json);
    }

    const selectedCategoryTemplate = (option: any, _props: any) => {
        if (option) {
            return categoryTemplate(option);
        }

        return (
            <span>
                {_props.placeholder}
            </span>
        );
    }

    const categoryTemplate = (option: any) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <ObjectsCategoryIcon className={`material-icons-${option.category_icon}`}>{option.category_icon.split(' ')[1]}</ObjectsCategoryIcon>
                <span style={{ color: "#6473FF" }}>{option.title}</span>
            </div>
        )
    }

    const handleUseBasePrice = (e: any) => {
        if (itemData) {
            if (!e.checked) {
                setItemPrice(itemData.price || 0)
            } else {
                setItemPrice(pricePreview)
            }
        } else {
            if (!e.checked) {
                setItemPrice(0)
            } else {
                setItemPrice(pricePreview)
            }
        }
        setUseBasePrice(e.checked)
        handleSetValue('is_base_price', e.checked)
    }

    const handleOnChangeInputNumber = (e: any) => {
        setItemPrice(e.value)
    }

    return (
        <>
            <CardDescription>
                <div className="title mb-2">Tipo de objeto</div>
                <Row className="mb-2">
                    <Col md={12}>
                        {
                            updateData ? (
                                <DropdownFilter>
                                    <Dropdown optionLabel="title" optionValue="id" value={category} options={categoriesItems} onChange={(e) => { handleCategorySelect(e) }}
                                        placeholder={translation("manager.selects.objectType")} itemTemplate={categoryTemplate} valueTemplate={selectedCategoryTemplate} />
                                </DropdownFilter>
                            ) : (
                                <>
                                    <div>
                                        <span><b>Categoria: </b> {itemData.category ? itemData.category.title : "Padrão"}</span>
                                    </div>
                                    {itemData && itemData?.delivery_values && itemData?.delivery_values?.map((values: any) => (
                                        <>
                                            <div>
                                                <span><b>{values.title}: </b> {values?.value}</span>
                                            </div>
                                        </>

                                    ))}
                                </>)
                        }
                    </Col>
                </Row>
                {updateData ? (<>
                    <Row className="mt-3">
                        <div className="title mb-2" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            {!!categoryIcon ? (
                                <ObjectsCategoryIcon style={{ color: "#606060", cursor: 'default', fontSize: 20 }} className={`material-icons-${categoryIcon}`}>{categoryIcon.split(' ')[1]}</ObjectsCategoryIcon>
                            ) : (
                                <ObjectsCategoryIcon style={{ color: "#606060", cursor: 'default', fontSize: 20 }} className={`material-icons-outlined sticky_note_2`}>sticky_note_2</ObjectsCategoryIcon>
                            )}
                            <span>Especificações</span>
                        </div>
                        <Col md={12} className="mb-3">
                            <Row>
                                <Col md={12} style={{ display: 'flex', flexDirection: 'column'}}>
                                    <Form.Label>Preço do material</Form.Label>
                                    <Controller
                                        name="price"
                                        control={control}
                                        rules={{ required: true }}
                                        defaultValue={itemPrice}
                                        render={({ field }) => (
                                            <>
                                                <InputNumber
                                                    value={field.value}
                                                    onValueChange={handleOnChangeInputNumber}
                                                    disabled={useBasePrice}
                                                    className="input-material-price w-100"
                                                    placeholder="R$ 0,00"
                                                    mode="currency"
                                                    currency="BRL"
                                                    locale="pt-BR"
                                                />
                                            </>
                                        )}
                                    />

                                    <Row className="mt-2">
                                        <Col xs={12}>
                                            <Checkbox 
                                                inputId="base_price"
                                                className="mr-1"
                                                disabled={pricePreview === null} 
                                                checked={useBasePrice} 
                                                onChange={handleUseBasePrice} 
                                            />
                                            <label htmlFor="base_price">Utilizar preço base</label>
                                        </Col>
                                    </Row>
                                    
                                    {
                                        category && pricePreview === null &&
                                        <Row className="mt-2">
                                            <Col style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                <span style={{ color: "#DD7B2A", fontSize: 14, fontWeight: 400 }}>Preço base não definido</span>
                                                <MdErrorOutline style={{ color: "#DD7B2A" }}/>
                                                <Link style={{ color: "#6473FF", fontSize: 14, fontWeight: 400 }} to="/manager/settings?pricingTab=true"> Configurar</Link>
                                            </Col>
                                        </Row>
                                    }

                                </Col>
                            </Row>

                        </Col>

                        {!!deliveryValues?.length && deliveryValues?.map((field: any) => (
                            <Col md={12} className="mb-3">
                                <FormGroup>
                                    <Form.Label>{field.title}</Form.Label>
                                    <Form.Control
                                        type={field?.type_field?.toLowerCase()} value={field.value ?? ""} required isInvalid={field.value ? false : true}
                                        onChange={(e) => handleValueChange(e, field)}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Este campo é obrigatório
                                    </Form.Control.Feedback>
                                </FormGroup>
                            </Col>
                        ))}
                    </Row>
                </>) : (<></>)}

            </CardDescription>
        </>
    )
}